import script from "./navbarSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./navbarSwitch.vue?vue&type=script&setup=true&lang=js"

import "./navbarSwitch.vue?vue&type=style&index=0&id=37ad5d3a&lang=css"

const __exports__ = script;

export default __exports__